import { createContext } from 'react'

export const QuickSelectContext = createContext()
